<template>
  <div class="default-layout">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-sidebar :user="user" />
      <main class="main" :class="{ 'main--full': !isPinActive }">
        <div v-if="isUserView" class="back-to-admin">
          <app-button @click.native="onBackToAdmin" size="small" theme="warn">Back to admin</app-button>
        </div>
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </main>
    </template>
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar'
import { isLoggedIn, setAuthTokens } from 'axios-jwt'
import { getMe } from '@/http'

export default {
  components: { AppSidebar },
  data() {
    return {
      is_loaded: false,
      user: null,
    }
  },
  created() {
    if (isLoggedIn()) {
      getMe()
        .then(res => {
          this.user = res.data
          this.$store.commit('setUserData', res.data)
          this.$store.commit('setUserGroups', res.data.groups)
          this.is_loaded = true
          if (this.$route.name === 'base') {
            if (this.user.groups.length && this.user.groups[0].index_page) {
              this.$router.push({ name: this.user.groups[0].index_page }).catch(() => {})
            } else {
              this.$router.push({ name: 'users' }).catch(() => {})
            }
          }
        })
    }
  },
  computed: {
    isPinActive() {
      return this.$store.state.isBigSidebar
    },
    isUserView() {
      return localStorage.getItem('access_admin')
    },
    getAccessAdmin() {
      return localStorage.getItem('access_admin')
    },
    getRefreshAdmin() {
      return localStorage.getItem('refresh_admin')
    },
  },
  methods: {
    onBackToAdmin() {
      const user_groups_admin = JSON.parse(localStorage.getItem('user_groups_admin'))
      this.$store.commit('setUserGroups', user_groups_admin)
      setAuthTokens({
        accessToken: this.getAccessAdmin,
        refreshToken: this.getRefreshAdmin
      })
      localStorage.removeItem('access_admin')
      localStorage.removeItem('refresh_admin')
      localStorage.removeItem('user_groups_admin')
      location.assign('/common/users')
    }
  }
}
</script>

<style lang="sass" scoped>
.back-to-admin
  position: fixed
  bottom: 10px
  right: 40px
  z-index: 999

.default-layout
  flex-grow: 1
  display: flex

.main
  flex-grow: 1
  margin-left: 220px
  padding: 35px 40px
  transition: margin-left 0.3s

  +max-w($desktop_sm)
    margin-left: 200px
    padding: 25px 15px

.main--full
  margin-left: 60px
  transition: margin-left 0.3s

.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
